import type { OracleResponse } from '@models/oracle'

export type OracleSource =
  | { kind: 'no-conv' }
  | { kind: 'cache'; responses: OracleResponse[] }
  | { kind: 'hydrated'; responses: OracleResponse[] }
  | { kind: 'skip-quick' }
  | { kind: 'fetch' }

interface MinimalState {
  oracle: { responseCache: Record<string, OracleResponse[]> }
  conversations: {
    conversations: Array<{
      id: string
      currentMode?: 'quick' | 'deep' | 'comprehensive'
      oracleInsightsData?: OracleResponse[] | null
    }>
  }
}

// Decides where Oracle data comes from for a given conversation.
// Order: redux cache → hydrated persisted data → mode gate → API fetch.
// The mode gate must run AFTER cache+hydration so a Quick-mode conversation
// that previously produced Oracle data still surfaces it.
export function resolveOracleSource(
  state: MinimalState,
  conversationId: string | null,
): OracleSource {
  if (!conversationId) return { kind: 'no-conv' }

  const cached = state.oracle.responseCache[conversationId]
  if (cached && cached.length > 0) {
    return { kind: 'cache', responses: cached }
  }

  const conv = state.conversations.conversations.find((c) => c.id === conversationId)
  const hydrated = conv?.oracleInsightsData
  if (Array.isArray(hydrated) && hydrated.length > 0) {
    return { kind: 'hydrated', responses: hydrated }
  }

  if (conv?.currentMode === 'quick') {
    return { kind: 'skip-quick' }
  }

  return { kind: 'fetch' }
}
